import * as http from '@/utils/http.js';

/**
 * 资源用户基础信息
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @param  {Number} crmId
 * @return {Promise}
 */
export function getBaseInfo(crmId) {
  return http._get({
    url: `/index/student/resource/id/${crmId}`
  });
}

/**
 * 资源用户基础信息
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @param  {Number} crmId
 * @return {Promise}
 */
export function getBaseInfoSee(crmId) {
  return http._get({
    url: `/index/student/resource/id/${crmId}/type/see`
  });
}

/**
 * 获取学生成绩信息
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @param  {Number} crmId
 * @return {Promise}
 */
export function getScores(crmId) {
  return http._get({
    url: `/index/student/assessmentScores/id/${crmId}`
  });
}

/**
 * 资源快照
 *
 * @param {Number} snapshotId
 */
export function getUserSnapshot(snapshotId) {
  return http._get({
    url: `/index/student/getsnapshot/id/${snapshotId}`
  });
}

/**
 * 获取当前面试的学校信息
 * @param {Number} userId
 */
export function currentInterviewSchool(userId) {
  return http._post({
    url: '/index/student/currentInterview',
    data: { id: userId }
  });
}

/**
 * 获取当前面试的学校信息
 * @param {Number} userId
 */
export function currentVisibleInterview(userId) {
  return http._post({
    url: '/index/student/currentVisibleInterview',
    data: { id: userId }
  });
}

export default {
  getScores
};
